export default __webpack_public_path__ + "static/media/hourglass.eec82bca.svg";